import { render, staticRenderFns } from "./TiktokUserIner.vue?vue&type=template&id=3429f546&scoped=true&"
import script from "./TiktokUserIner.vue?vue&type=script&lang=ts&"
export * from "./TiktokUserIner.vue?vue&type=script&lang=ts&"
import style0 from "./TiktokUserIner.vue?vue&type=style&index=0&id=3429f546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429f546",
  null
  
)

export default component.exports